export const subPermissionKeys = {
  groupKey: 'collaborator',

  read: 'collaborators-birth-month',
};
